import React, { Component } from "react";
import "./MonthlyReportsTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faEdit,
  faDownload,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ViewModal from "./ViewModal";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

class MonthlyReportsTable extends Component {
  state = {
    MonthlyReportsData: [],
    loading: true,
    modalShow: false,
    SelectRepo: null,

    columnDefs: [
      {
        headerName: "View Report",
        field: "view",
        filter: false,
        width: 120,
        cellRendererFramework: this.renderViewButton.bind(this),
      },
      {
        headerName: "Attachment",
        field: "FileLinks",
        sortable: true,
        cellRendererFramework: this.renderDownloadButton.bind(this),
        width: 150,
        // filter: true ,
      },
      {
        headerName: "Month & Year",
        field: "monthyear",
        sortable: true,
        width: 140,
        // filter: true ,
      },
      {
        headerName: "Modifed on",
        field: "EditDate",
        sortable: true,
        width: 140,
        // filter: true ,
      },

      {
        headerName: "Edit",
        field: "edit",
        filter: false,
        width: 120,
        cellRendererFramework: this.renderEditButton.bind(this),
      },
      {
        headerName: "Delete",
        field: "delete",
        filter: false,
        width: 120,
        cellRendererFramework: this.renderButton.bind(this),
      },
    ],
    rowData: [],
    defaultColDef: {
      resizable: true,
      width: 295,
      filter: "agTextColumnFilter",
      // filter: true ,
    },
    getRowHeight: function (params) {
      return 55;
    },
  };
  MonthlyReportsObj = [];
  rowDataT = [];

  loadMonthlyReportsData = () => {
    axios
      .get(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/monthlyreports/" +
          this.props.data["_id"],
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )

      .then((response) => {
        this.MonthlyReportsObj = response.data;
        this.setState({ MonthlyReportsData: response.data });
        this.setState({ loading: false });
        this.rowDataT = [];
        // let data=this.MonthlyReportsObj.MonthlyReports["0"];
        this.MonthlyReportsObj.monthlyreport.reverse().map((data) => {
          let temp = {
            data,
            monthyear: data.monthyear,
            EditDate: data.EditDate.split(" ")
              .slice(0, 5)
              .join(" ")
              .split(":")
              .slice(0, 2)
              .join(":"),
            Text: data.Text,
          };
          this.rowDataT.push(temp);
        });
        this.setState({ rowData: this.rowDataT });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onMonthlyReportsDelete = (e1, e2) => {
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/monthlyreports/" +
            e1 +
            "/" +
            e2,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          this.componentDidMount();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  DownloadLink = (link) => {
    window.open("https://almawridems.javedahmadghamidi.com/" + link);
  };
  componentDidMount() {
    this.loadMonthlyReportsData();
  }
  ViewReport(report) {
    this.setState({ SelectRepo: report, modalShow: true });
  }
  renderButton(params) {
    // console.log(params);
    if (this.props.back) {
      return <React.Fragment />;
    }
    return (
      <Button
        variant="light"
        onClick={() =>
          this.onMonthlyReportsDelete(
            this.props.data["_id"],
            params.data.data["_id"]
          )
        }>
        <FontAwesomeIcon icon={faTrash} />
        &nbsp;&nbsp;Delete
      </Button>
    );
  }
  renderViewButton(params) {
    // console.log(params);
    if (this.props.back) {
      return <React.Fragment />;
    }
    return (
      <Button variant="light" onClick={() => this.ViewReport(params.data.data)}>
        <FontAwesomeIcon icon={faEye} /> &nbsp;&nbsp; View
      </Button>
    );
  }
  renderDownloadButton(params) {
    // console.log(params);
    if (this.props.back) {
      return <React.Fragment />;
    }
    return (
      <Button
        variant="light"
        onClick={() => this.DownloadLink(params.data.data.FileLinks)}>
        <FontAwesomeIcon icon={faDownload} />
        &nbsp;&nbsp;Attachment
      </Button>
    );
  }
  renderEditButton(params) {
    // console.log(params);
    if (this.props.back) {
      return <React.Fragment />;
    }
    return (
      <Button
        variant="light"
        onClick={() => this.props.onEditMonthlyReports(params.data.data)}>
        <FontAwesomeIcon icon={faEdit} />
        &nbsp;&nbsp;Edit
      </Button>
    );
  }

  render() {
    return (
      <div id="table-outer-div-scroll">
        <h2 id="role-title">
          Employee Monthly Reports Details{" "}
          {this.props.back
            ? "of " +
              this.props.data["FirstName"] +
              " " +
              this.props.data["LastName"]
            : ""}
        </h2>

        {this.props.back ? (
          <Link to="/hr/employee">
            <Button variant="primary" id="add-button">
              Back
            </Button>
          </Link>
        ) : (
          <Button
            variant="primary"
            id="add-button"
            onClick={this.props.onAddMonthlyReports}>
            <FontAwesomeIcon icon={faPlus} id="plus-icon" />
            Add
          </Button>
        )}

        <div id="clear-both" />

        {!this.state.loading ? (
          <div
            id="table-div"
            className="ag-theme-balham"
            //   style={
            //     {
            //     height: "500px",
            //     width: "100%"
            //   }
            // }
          >
            <AgGridReact
              columnDefs={this.state.columnDefs}
              defaultColDef={this.state.defaultColDef}
              rowData={this.state.rowData}
              // floatingFilter={true}
              // onGridReady={this.onGridReady}
              pagination={true}
              paginationPageSize={10}
              getRowHeight={this.state.getRowHeight}
            />
          </div>
        ) : (
          <div id="loading-bar">
            <RingLoader
              css={override}
              sizeUnit={"px"}
              size={50}
              color={"#0000ff"}
              loading={true}
            />
          </div>
        )}
        {this.state.SelectRepo && (
          <ViewModal
            show={this.state.modalShow}
            onHide={() => this.setState({ modalShow: false, SelectRepo: null })}
            SelectRepo={this.state.SelectRepo}
          />
        )}
      </div>
    );
  }
}

export default MonthlyReportsTable;
